import React from "react";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
  SubTitle,
} from "chart.js";
import moment from "moment";
import { Line } from "react-chartjs-2";
import "./DashboardGraph.scss";
import { Stack } from "@mui/system";
ChartJS.register(
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
  SubTitle
);

const DashboradGraph = (props) => {
  let primaryLabel, subLabel, xPos;
  let _tickInternalIndex = -1;
  let _tickCenterIndex = 0;
  let centerPoints = [];
  let endValuePerPoint = [];
  let newEndValuePerPoint = [];
  let modifiedPrimaryLabels = [];

  const runninggraphData = props.runninggraphData ?? {};
  const stoppedgraphData = props.stoppedgraphData ?? {};
  const completedgraphData = props.completedgraphData ?? {};
  const totalStudents = props.totalStudents ?? {};
  const totalInstructors = props.totalInstructors ?? {};
  const avgSessionLength = props.avgSessionLength ?? {};
  const totalHours = props.totalHours ?? {};
  const totalTraining = props.totalTraining ?? {};

  let singleDayData;
  let length;

  const singleDay = (VMStatusData, data, index) => {
    const singleDayData = [];

    if (VMStatusData !== undefined) {
      console.log("Index", index);
      singleDayData.push(0);

      if (Array.isArray(data)) {
        singleDayData.push(...data);
      } else {
        singleDayData.push(data);
      }

      singleDayData.push(0);
    }

    return singleDayData;
  };
  const generateDaysArray = (plotPoints, xPos) => {
    length = plotPoints[0].days.length;
    if (xPos === "subLabels") {
      subLabel = plotPoints
        .map((plotPoint, index) => {
          console.log("p3", plotPoint.days.length);
          centerPoints.push(Math.floor(plotPoint.days.length / 2));
          endValuePerPoint.push(plotPoint.days.length - 1);
          newEndValuePerPoint.push(
            (plotPoint.days.length - 1 === 0 ? 1 : plotPoint.days.length - 1) +
              (newEndValuePerPoint[index - 1] ?? 0)
          );
          console.log(newEndValuePerPoint[index - 1]);
          return plotPoint.days;
        })
        .flat();
    }
    console.log("ssD", singleDayData);
    if (xPos === "primaryLabels") {
      primaryLabel = plotPoints
        .map((plotPoint) => {
          return plotPoint.month;
        })
        .flat();
    }
  };
  const getMonths = (plotPoints, xPos) => {
    if (xPos === "subLabels") {
      subLabel = plotPoints
        .map((plotPoint, index) => {
          centerPoints.push(Math.floor(plotPoint.month.length / 2));
          endValuePerPoint.push(plotPoint.month.length - 1);
          newEndValuePerPoint.push(
            plotPoint.month.length - 1 + (newEndValuePerPoint[index - 1] ?? 0)
          );
          return plotPoint.month;
        })
        .flat();
    }
    if (xPos === "primaryLabels") {
      primaryLabel = plotPoints.map((plotPoint) => plotPoint.year).flat();
    }
  };
  const getWeeks = (plotPoints, xPos) => {
    if (xPos === "subLabels") {
      subLabel = plotPoints
        .map((plotPoint, index) => {
          centerPoints.push(Math.floor(plotPoint.weeks.length / 2));
          endValuePerPoint.push(plotPoint.weeks.length - 1);
          newEndValuePerPoint.push(
            plotPoint.weeks.length - 1 + (newEndValuePerPoint[index - 1] ?? 0)
          );
          return plotPoint.weeks;
        })
        .flat();
    }
    if (xPos === "primaryLabels") {
      primaryLabel = plotPoints.map((plotPoint) => plotPoint.month).flat();
    }
  };

  const getYears = (plotPoints, xPos) => {
    if (xPos === "subLabels") {
      subLabel = plotPoints.map((plotPoint) => plotPoint.year);
    }
  };

  const getXAxisLabels = (plotPoints, interval, xPos) => {
    let data = [];
    switch (interval) {
      case "years":
        data = getYears(plotPoints, xPos);
        break;
      case "months":
        data = getMonths(plotPoints, xPos);
        break;
      case "weeks":
        data = getWeeks(plotPoints, xPos);
        break;
      case "days":
        data = generateDaysArray(plotPoints, xPos);
        break;
      default:
        break;
    }
    return data;
  };

  const interval = props.interval;
  getXAxisLabels(props.plotPoints, interval, "subLabels");
  getXAxisLabels(props.plotPoints, interval, "primaryLabels");
  let checkIndex = centerPoints[_tickCenterIndex];

  console.log("centerPoints", centerPoints, "primaryLabel", primaryLabel);
  console.log("endPoints: ", endValuePerPoint);
  console.log("endPt: ", newEndValuePerPoint);

  console.log("sublabel", subLabel);
  let subLabel2;
  let primaryLabel2;
  if (subLabel && subLabel.length === 1) {
    subLabel2 = [" ", subLabel[0], " "];
    console.log("ss2", subLabel2);
    primaryLabel2 = [" ", primaryLabel[0], " "];
    console.log(primaryLabel2);
  }

  const modifyPrimaryLabel = (subLabel) => {
    for (let i = 0; i < subLabel.length; i++) {
      console.log("i", i);
      console.log("checkIndex", checkIndex);
      if (i === checkIndex) {
        _tickCenterIndex++;
        _tickInternalIndex++;
        if (interval === "days") {
          checkIndex = Math.ceil(
            (newEndValuePerPoint[_tickCenterIndex] +
              newEndValuePerPoint[_tickCenterIndex - 1]) /
              2
          );
        } else if (interval === "weeks") {
          checkIndex =
            Math.ceil(
              (newEndValuePerPoint[_tickCenterIndex] +
                newEndValuePerPoint[_tickCenterIndex - 1]) /
                2
            ) + 1;
        } else if (interval === "months") {
          checkIndex =
            Math.ceil(
              (newEndValuePerPoint[_tickCenterIndex] +
                newEndValuePerPoint[_tickCenterIndex - 1]) /
                2
            ) + 1;
        }
        modifiedPrimaryLabels.push(primaryLabel[_tickInternalIndex]);
      } else {
        modifiedPrimaryLabels.push("");
      }

      console.log(modifiedPrimaryLabels);
    }
    return modifiedPrimaryLabels;
  };
  console.log("pp", primaryLabel);

  const runningPeriod = [];
  if (interval === "years") {
    runningPeriod.push(
      Object.keys(runninggraphData).map((year) => {
        return runninggraphData[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    runningPeriod.push(
      Object.keys(runninggraphData)
        .map((month) => {
          return Object.values(runninggraphData[month]).map(
            (item) => item.count
          );
        })
        .flat()
    );
  }

  const stoppedPeriod = [];
  if (interval === "years") {
    stoppedPeriod.push(
      Object.keys(stoppedgraphData).map((year) => {
        return stoppedgraphData[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    stoppedPeriod.push(
      Object.keys(stoppedgraphData)
        .map((month) => {
          return Object.values(stoppedgraphData[month]).map(
            (item) => item.count
          );
        })
        .flat()
    );
  }
  const completedPeriod = [];
  if (interval === "years") {
    completedPeriod.push(
      Object.keys(completedgraphData).map((year) => {
        return completedgraphData[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    completedPeriod.push(
      Object.keys(completedgraphData)
        .map((month) => {
          return Object.values(completedgraphData[month]).map(
            (item) => item.count
          );
        })
        .flat()
    );
  }
  const totalTrainingPeriod = [];
  if (interval === "years") {
    totalTrainingPeriod.push(
      Object.keys(totalTraining).map((year) => {
        return totalTraining[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    totalTrainingPeriod.push(
      Object.keys(totalTraining)
        .map((month) => {
          return Object.values(totalTraining[month]).map((item) => item.count);
        })
        .flat()
    );
  }
  const totalStudentsArray = [];
  if (interval === "years") {
    totalStudentsArray.push(
      Object.keys(totalStudents).map((year) => {
        return totalStudents[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    totalStudentsArray.push(
      Object.keys(totalStudents)
        .map((month) => {
          return Object.values(totalStudents[month]).map((item) => item.count);
        })
        .flat()
    );
  }
  const totalInstructorsArray = [];
  if (interval === "years") {
    totalInstructorsArray.push(
      Object.keys(totalInstructors).map((year) => {
        return totalInstructors[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    totalInstructorsArray.push(
      Object.keys(totalInstructors)
        .map((month) => {
          return Object.values(totalInstructors[month]).map(
            (item) => item.count
          );
        })
        .flat()
    );
  }
  const averageSessinLPeriod = [];
  if (interval === "years") {
    averageSessinLPeriod.push(
      Object.keys(avgSessionLength).map((year) => {
        return avgSessionLength[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    averageSessinLPeriod.push(
      Object.keys(avgSessionLength)
        .map((month) => {
          return Object.values(avgSessionLength[month]).map(
            (item) => item.count
          );
        })
        .flat()
    );
  }
  const totalHoursArray = [];
  if (interval === "years") {
    totalHoursArray.push(
      Object.keys(totalHours).map((year) => {
        return totalHours[year].count;
      })
    );
  } else if (
    interval === "months" ||
    interval === "weeks" ||
    interval === "days"
  ) {
    totalHoursArray.push(
      Object.keys(totalHours)
        .map((month) => {
          return Object.values(totalHours[month]).map((item) => item.count);
        })
        .flat()
    );
  }

  const data = {
    labels: subLabel && subLabel.length === 1 ? subLabel2 : subLabel,

    datasets: [
      {
        label: "Running Instance",
        lineTension: 0.4,
        backgroundColor: "#21D59B",
        borderColor: "#21D59B",

        data:
          length === 1
            ? singleDay(props.runninggraphData, runningPeriod[0])
            : runningPeriod[0],
      },
      {
        label: "Stop Instance",
        lineTension: 0.4,
        backgroundColor: "#FF8800",
        borderColor: "#FF8800",

        data:
          length === 1
            ? singleDay(props.stoppedgraphData, stoppedPeriod[0])
            : stoppedPeriod[0],
      },
      {
        label: "Terminated Instance",
        lineTension: 0.4,
        backgroundColor: "#FF0000",
        borderColor: "#FF0000",

        data:
          length === 1
            ? singleDay(props.completedgraphData, completedPeriod[0])
            : completedPeriod[0],
      },
      {
        label: "Total Training",
        lineTension: 0.4,
        backgroundColor: "#3a86ff",
        borderColor: "#3a86ff",
        data:
          length === 1
            ? singleDay(props.totalTraining, totalTrainingPeriod[0])
            : totalTrainingPeriod[0],
      },

      {
        label: "Total Students",
        lineTension: 0.4,
        backgroundColor: "#8338ec",
        borderColor: "#8338ec",
        data:
          length === 1
            ? singleDay(props.totalStudents, totalStudentsArray[0])
            : totalStudentsArray[0],
      },
      {
        label: "Total Instructors",
        lineTension: 0.4,
        backgroundColor: "#ff006e",
        borderColor: "#ff006e",

        data:
          length === 1
            ? singleDay(props.totalInstructors, totalInstructorsArray[0])
            : totalInstructorsArray[0],
      },
      {
        label: "Average Session Length",
        lineTension: 0.4,
        backgroundColor: "#fb5607",
        borderColor: "#fb5607",

        data:
          length === 1
            ? singleDay(props.avgSessionLength, averageSessinLPeriod[0])
            : averageSessinLPeriod[0],
      },
      {
        label: "Total Hours",
        lineTension: 0.4,
        backgroundColor: "#ffbe0b",
        borderColor: "#ffbe0b",

        data:
          length === 1
            ? singleDay(props.totalHours, totalHoursArray[0])
            : totalHoursArray[0],
      },
    ],
  };
  console.log("singleday", singleDay(props.totalHours, totalHoursArray[0]));

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      xAxis: {
        border: {
          display: true,
          color: "#fff",
          width: 1,
        },
        grid: {
          borderColor: "grey", // <-- this line is answer to initial question
        },

        ticks: {
          color: "#fff",
          // offset: subLabel && subLabel.length === 1 ? true : false,

          font: {
            size: 14,
          },
        },
      },
      xAxis2: {
        labels:
          subLabel && subLabel.length === 1
            ? primaryLabel2
            : modifyPrimaryLabel(subLabel ?? []) ?? [],
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxTicksLimit: 10,
          maxRotation: 0,

          color: "#fff",
          font: {
            size: 14,
          },
        },
      },
      yAxis: {
        grid: {
          borderColor: "grey",
        },

        gridLines: {
          zeroLineColor: "#ffcc33",
        },
        ticks: {
          color: "#fff",

          font: {
            size: 14,
          },
        },
        min: 0,
      },
    },
  };
  return (
    <>
      <Stack className="dashboard_Graph">
        <Line data={data} options={options} />
      </Stack>
    </>
  );
};

export default DashboradGraph;
